export const convertImageDataURLToFile = async (imageData: string) => {
  const base64Res = await fetch(imageData);
  const arrayBuffer = await base64Res.arrayBuffer();
  const file = new File([arrayBuffer], 'cover.jpeg', { type: 'image/jpeg' });
  return file;
};
